// extracted by mini-css-extract-plugin
module.exports = {"container":"Fallback_container__2ZthX","imageWrapper":"Fallback_imageWrapper__MiM9X"};